// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcv_a bhh_rh bhh_ri bhh_vf bhh_ec bhh_vc bhh_gq bhh_kf"};